export default {
  step0: {
    title: 'Fill in the phone number',
    desc: 'This is necessary for your<br> verification on the portal'
  },
  step1: {
    title: 'Enter the code from the SMS',
    desc: 'We sent it to the number:',
    descRefresh: 'A resend is possible through:',
    seconds: 'seconds',
    refreshSend: 'Resend'
  },
  step2: {
    title: 'Success',
    desc: 'Thank you for being verified on the portal',
  },
  step3: {
    title: 'Oops!',
    desc: 'You are already verified',
  },
  back: 'Back',
  changeNumber: 'Change number',
  sendCode: 'Send code',
  error: {
    codeIsAlreadyExpired: 'The code has expired',
    codeIsIncorrect: 'Неверный проверочный код',
    alreadyValidated: 'Incorrect verification code',
    unknownError: 'Unknown error'
  }
}
